import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import SchoolsMap from './SchoolsMap';
import SchoolsMobileMap from './SchoolsMobileMap';
import SchoolsList from './SchoolsList';
import SchoolsSearch from './SchoolsSearch';
import {withLocalize} from 'react-localize-redux';
import translations from '../../translations/translations_schools_list';

class SchoolsListContainer extends Component {
    mapColRef = React.createRef();

    state = {
        mapWrapperWidth: 0,
        mapWrapperHeight: 0,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        this.resizeMapWrapper();
        window.addEventListener('resize', this.resizeMapWrapper);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeMapWrapper);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.props.loading && (Array.isArray(this.props.schools) && this.props.schools.length > 0) && (prevProps.schools !== this.props.schools)) {
            this.resizeMapWrapper();
        }
    }

    resizeMapWrapper = () => {
        let w = window,
            d = document,
            documentElement = d.documentElement,
            body = d.getElementsByTagName('body')[0],
            width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
            height = w.innerHeight || documentElement.clientHeight || body.clientHeight;

        if (this.mapColRef) {
            let offset = this.mapColRef.current.offsetLeft + 15; // offsetLeft + Bootstrap grid gutter

            let newMapWrapperWidth = this.state.mapWrapperWidth;

            if (width > offset) {
                newMapWrapperWidth = width - offset;
            }

            let headerHeight = document.getElementById('site-header').offsetHeight;
            //let mapHeight = (height - headerHeight) + 200; // (Window height - header) + map gradient
            let mapHeight = height;

            /*if (!this.props.loading && (Array.isArray(this.props.schools) && this.props.schools.length > 6)) {
                let contentHeight = document.getElementsByClassName('col-results')[0].offsetHeight;
                if (contentHeight > mapHeight) {
                    mapHeight = contentHeight;
                }
            }*/

            this.setState({
                mapWrapperWidth: newMapWrapperWidth,
                mapWrapperHeight: mapHeight,
            });
        }
    };

    render() {
        const pageTitle = this.props.translate('schools_list.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'schools-list'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <div className="row">
                        <div className="col col-results col-12 col-lg-8">
                            <SchoolsSearch/>
                            <SchoolsList/>
                        </div>
                        <div className="col col-map col-4 d-none d-lg-block" ref={this.mapColRef} style={{minHeight: this.state.mapWrapperHeight}}>
                            <div className="inner" style={{width: this.state.mapWrapperWidth, height: this.state.mapWrapperHeight}}>
                                {/*<div className="gradient"></div>*/}
                                <SchoolsMap/>
                            </div>
                        </div>
                        <SchoolsMobileMap/>
                    </div>
                </div>
            </Fragment>
        );
    }
}

SchoolsListContainer.propTypes = {
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    schools: state.schools.schools,
    loading: state.schools.schoolsLoading,
});

export default connect(mapStateToProps, {})(withLocalize(SchoolsListContainer));


// WEBPACK FOOTER //
// ./src/features/Schools/components/List/SchoolsListContainer.js